<template>
<div class="nodata">
  <div class="nodata_warpper">
    <img src="@/assets/images/empty.png" /> 
  </div>
</div>
</template>
<script>
export default {
  data() {
    return {};
  },
  components: {

  },
  created() {},
  mounted() {

  }
};
</script>
<style>
.nodata{
  text-align: center
}
.nodata_warpper img{
  width:100%;
}
</style>
